import { useQueryClient } from '@tanstack/react-query'

import {
  useNotesServicePatchV1IndividualsByIndividualIdNotesByNoteId,
} from '../client/queries'
import {
  useNotesServiceGetV1IndividualsByIndividualIdNotesByNoteIdKey,
  useNotesServiceGetV1IndividualsByIndividualIdNotesKey,
} from '../client/queries/common'

export const useUpdateNote = () => {
  const queryClient = useQueryClient()

  return useNotesServicePatchV1IndividualsByIndividualIdNotesByNoteId({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useNotesServiceGetV1IndividualsByIndividualIdNotesKey],
      })
      queryClient.invalidateQueries({
        queryKey: [useNotesServiceGetV1IndividualsByIndividualIdNotesByNoteIdKey],
      })
    },
  })
}
